import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import AbstractForm from '../forms/AbstractForm'
import { Typography } from '../styled'
import theme from '../../constants/theme'
import { RANGE_MODES } from '../../utilities/eliminatingQuestions'

function RangeQuestion({ question, index, setEliminatingAnswers }) {
  const { t } = useTranslation()
  const mode = question.answer?.mode || RANGE_MODES.RANGE_VALUE

  const singleValueInputs = [
    {
      name: `value`,
      label: t('rangeQuestion.value'),
      renderType: 'number',
      type: 'number',
      min: question.answer?.min || 0,
      max: question.answer?.max || 1000,
      required: true,
      width: 12,
    },
  ]

  const rangeValueInputs = [
    {
      name: `from`,
      label: t('rangeQuestion.from'),
      renderType: 'number',
      type: 'number',
      min: 0,
      required: true,
      width: 6,
    },
    {
      name: `to`,
      label: t('rangeQuestion.to'),
      renderType: 'number',
      type: 'number',
      min: 0,
      required: true,
      width: 6,
    },
  ]

  const inputs =
    mode === RANGE_MODES.SINGLE_VALUE ? singleValueInputs : rangeValueInputs

  const handleFormWatch = (value) => {
    if (mode === RANGE_MODES.SINGLE_VALUE) {
      if (value.value !== undefined) {
        setEliminatingAnswers((prev) => [
          ...prev.filter((a) => a.id !== question.id),
          {
            id: question.id,
            answer: { value: Number(value?.value) },
          },
        ])
      }
    } else {
      if (value.from !== undefined && value.to !== undefined)
        setEliminatingAnswers((prev) => [
          ...prev.filter((a) => a.id !== question.id),
          {
            id: question.id,
            answer: { start: Number(value?.from), end: Number(value?.to) },
          },
        ])
    }
  }

  return (
    <>
      {' '}
      <p className="mt-4 mb-3">
        <Typography
          backgroundColor={theme.cardBorder}
          color={theme.brandColorOrange}
          size={18}
        >
          {`Q${index}.`}
        </Typography>{' '}
        <Typography backgroundColor={theme.cardBorder} color={theme.inputField}>
          {question.question}
        </Typography>
      </p>
      <AbstractForm
        inputs={inputs}
        handleFormWatch={(value) => handleFormWatch(value)}
      />
    </>
  )
}

export default RangeQuestion

RangeQuestion.defaultProps = {
  setEliminatingAnswers: () => {},
  index: 0,
  question: PropTypes.shape({
    id: '',
    question: '',
    answer_type: '',
    answer: {},
    show: false,
  }),
}

RangeQuestion.propTypes = {
  setEliminatingAnswers: PropTypes.func,
  index: PropTypes.number,
  question: PropTypes.shape({
    id: PropTypes.string.isRequired,
    question: PropTypes.string.isRequired,
    answer_type: PropTypes.string.isRequired,

    // eslint-disable-next-line react/forbid-prop-types
    answer: PropTypes.object.isRequired,
    show: PropTypes.bool,
  }),
}
